module.exports = __webpack_public_path__ + "1263cb6780e119de7666c96dd84c95a0.svg";


//////////////////
// WEBPACK FOOTER
// ./images/saIcon.svg
// module id = 42
// module chunks = 0